import React, { useEffect } from "react";

export const usePersistedState = <T>(key: string, defaultValue: T) => {
  const [state, setState] = React.useState(() => {
    let item = localStorage.getItem(key);
    if (item) return JSON.parse(item) as T;
    else return defaultValue;
  });
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);
  return { state, setState };
};

export type ReactSetState<T> = React.Dispatch<React.SetStateAction<T>>;
